import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../constants/common'
import { formValidationSchemaNoChanged } from '../../Form'
import {
  DOCUMENT_ACCESS_LEVEL,
  DOCUMENT_ACCESS_LEVEL_RANK,
} from '../Document.constants'

import {
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_INHERIT_PERMISSIONS,
  DOCUMENT_EDIT_ACCESS_ROLES,
  DOCUMENT_EDIT_ACCESS_ROLES_HIERARCHY,
} from './DocumentEditAccessActionModal.constants'

// initialValues is either the levels object (permission_groups_detail),
// the legacy flat role list (permission_groups) or undefined
function getPermissionLevels(initialValues) {
  if (Array.isArray(initialValues)) {
    return Object.fromEntries(
      DOCUMENT_EDIT_ACCESS_ROLES.map(role => [
        role,
        initialValues.includes(role)
          ? DOCUMENT_ACCESS_LEVEL.allow
          : DOCUMENT_ACCESS_LEVEL.deny,
      ])
    )
  }

  return Object.fromEntries(
    DOCUMENT_EDIT_ACCESS_ROLES.map(role => [
      role,
      initialValues?.[role] || DOCUMENT_ACCESS_LEVEL.deny,
    ])
  )
}

export function getDocumentEditAccessValidationSchema({
  checkNoChanges,
  initialValues,
}) {
  return Yup.object({
    [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS]: Yup.object(),
    [DOCUMENT_EDIT_ACCESS_FIELD_NAME_INHERIT_PERMISSIONS]:
      Yup.boolean().nullable(),
  }).when(EMPTY_LIST, {
    is: () => checkNoChanges,
    then: schema =>
      schema.concat(formValidationSchemaNoChanged({ initialValues })),
  })
}

export function getAccessInitialValues({ initialValues, isFolder, isManager }) {
  const levels = getPermissionLevels(initialValues)

  return {
    [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS]: {
      ...levels,
      // the backend rejects any admin level except allow
      [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS]:
        DOCUMENT_ACCESS_LEVEL.allow,
      [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER]: isManager
        ? DOCUMENT_ACCESS_LEVEL.allow
        : levels[DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER],
    },
    ...(isFolder
      ? { [DOCUMENT_EDIT_ACCESS_FIELD_NAME_INHERIT_PERMISSIONS]: true }
      : null),
  }
}

export function getAdjustedAccessLevels({ levels, nextLevel, role }) {
  const { above = EMPTY_LIST, below = EMPTY_LIST } =
    DOCUMENT_EDIT_ACCESS_ROLES_HIERARCHY[role]

  const nextLevelRank = DOCUMENT_ACCESS_LEVEL_RANK[nextLevel]

  return Object.fromEntries(
    Object.entries(levels).map(([currentRole, level]) => {
      const isRaised =
        above.includes(currentRole) &&
        DOCUMENT_ACCESS_LEVEL_RANK[level] < nextLevelRank

      const isLowered =
        below.includes(currentRole) &&
        DOCUMENT_ACCESS_LEVEL_RANK[level] > nextLevelRank

      return [
        currentRole,
        currentRole === role || isRaised || isLowered ? nextLevel : level,
      ]
    })
  )
}
